import React from 'react';

import { Button } from '@hpstellar/core';
import { ArrowRight, ArrowLeft } from '@hpstellar/icons';

import { ToggleLeftMenu } from '../../left-menu/left-menu-container';
import '../css/filter-compare-toggle.less';

export default ({ defaultExpanded, text = 'Filters & Compare', menuID }, isV2 = false) => {
    if (isV2) {
        return (
            <ToggleLeftMenu defaultExpanded={defaultExpanded} menuID={menuID}>
                {({ dispatchMenuState, leftMenuActive }) => {
                    return (
                        <Button
                            className={`filterToggleButton`}
                            color="dark"
                            size="small"
                            startIcon={leftMenuActive === 'back' && <ArrowLeft size="s" />}
                            endIcon={leftMenuActive === 'go' && <ArrowRight size="s" />}
                            onClick={() => {
                                dispatchMenuState(!leftMenuActive);
                            }}
                        >
                            {`${leftMenuActive ? 'Hide' : 'Show'} ${text}`}
                        </Button>
                    );
                }}
            </ToggleLeftMenu>
        );
    }

    return (
        <ToggleLeftMenu defaultExpanded={defaultExpanded}>
            {({ dispatchMenuState, leftMenuActive }) => {
                return (
                    <button
                        className={`toggle-left-menu unstyled ${leftMenuActive ? ' active' : ''}`}
                        onClick={() => {
                            dispatchMenuState(!leftMenuActive);
                        }}
                    >
                        {`${leftMenuActive ? 'Hide' : 'Show'} ${text}`}
                        {[0, 1].map(i => (
                            <span key={i} className={`hp-icon ${leftMenuActive ? 'page-left' : 'page-right'}`}></span>
                        ))}
                    </button>
                );
            }}
        </ToggleLeftMenu>
    );
};
